import { ExternalLink } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

const Partners = () => {
    const { t } = useLanguage();
    const P = t.partners;
    return (
        <section
            id="partners"
            data-testid="partners-section"
            className="bg-ella-cream pb-24 md:pb-28 -mt-8 md:-mt-10"
        >
            <div className="ella-container">
                {/* Hairline separator */}
                <div className="border-t border-ella-line pt-14 md:pt-16">
                    <div className="text-center max-w-2xl mx-auto">
                        <div className="inline-flex items-center gap-3">
                            <span className="gold-hairline" />
                            <span className="ella-overline">{P.overline}</span>
                            <span className="gold-hairline" />
                        </div>
                        <h3
                            className="font-display text-3xl md:text-4xl mt-4 text-ella-ink"
                            data-testid="partners-title"
                        >
                            {P.title}
                        </h3>
                        <p className="mt-4 text-ella-ink/70 font-light text-base leading-relaxed">
                            {P.subtitle}
                        </p>
                    </div>

                    <div className="mt-12 md:mt-14 grid sm:grid-cols-2 md:grid-cols-3 gap-6 lg:gap-8 max-w-5xl mx-auto">
                        {P.items.map((p, i) => (
                            <a
                                key={p.name}
                                href={p.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid={`partner-${p.name.toLowerCase()}`}
                                className="group block bg-white border border-ella-line rounded-3xl p-7 md:p-8 hover:border-ella-gold/60 hover:shadow-[0_18px_50px_rgba(193,154,107,0.10)] transition-all duration-500"
                            >
                                {/* Logo */}
                                <div className="relative h-20 md:h-24 flex items-center justify-center bg-ella-cream/60 rounded-2xl border border-ella-line/60 px-6">
                                    <img
                                        src={p.logo}
                                        alt={`${p.name} Logo`}
                                        className="max-h-full max-w-full object-contain transition-all duration-500 group-hover:scale-[1.02]"
                                    />
                                    {p.badge && (
                                        <span className="absolute -top-2.5 left-5 px-2.5 py-1 rounded-full bg-ella-ink text-ella-gold text-[9px] uppercase tracking-[0.22em]">
                                            {p.badge}
                                        </span>
                                    )}
                                </div>
                                {/* Content */}
                                <div className="mt-6 flex items-baseline justify-between gap-3">
                                    <div>
                                        <p className="font-display text-xl text-ella-ink leading-none">
                                            {p.name}
                                        </p>
                                        <p className="ella-overline mt-2">
                                            {p.fullName}
                                        </p>
                                    </div>
                                    <ExternalLink
                                        className="w-4 h-4 text-ella-muted group-hover:text-ella-gold-dark transition-colors flex-shrink-0"
                                        strokeWidth={1.5}
                                    />
                                </div>
                                <p className="mt-4 text-[13.5px] text-ella-ink/70 leading-relaxed font-light">
                                    {p.description}
                                </p>
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Partners;
